import styled from 'astroturf/react';
import Footer from 'src/components/Footer';
import Header from 'src/components/Header';

const footer = styled(Footer)`
  padding: 30px 0 0;
  justify-content: space-between;
`;

const header = styled(Header)`
  margin-bottom: 20px;
`;

const layout = styled('div')`
  position: relative;
  min-height: 100%;
  height: 100%;
  overflow: auto;
`;

export default {
  Footer: footer,
  Layout: layout,
  Header: header,
};
